import { render, staticRenderFns } from "./CompanyCardBillingAddress.vue?vue&type=template&id=ce9e1716&scoped=true&"
import script from "./CompanyCardBillingAddress.vue?vue&type=script&lang=ts&"
export * from "./CompanyCardBillingAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9e1716",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
